import { Browser as CapacitorBrowser } from "@capacitor/browser";
import { NavigateFunction } from "react-router-dom";
import { URLShortenerApi } from "./api/api/urlshortener-api";
import { isiOSApp } from "./client";

export class Urls {
    static urlShortenerApi: URLShortenerApi;

    static initialise(urlShortenerApi: URLShortenerApi) {
        Urls.urlShortenerApi = urlShortenerApi;
    }

    static async redirectToPathNormalise(
        requestedUrl: string,
        navigate: NavigateFunction | null = null
    ) {
        console.log("redirectToPathNormalise", requestedUrl);

        // iOS may receive shortened urls, if so try and resolve the url
        // This may include dstr.to and qa.dstr.to.
        if (requestedUrl.includes("dstr.to/")) {
            const shortenUrlSlug = requestedUrl.split("dstr.to/").pop();
            if (shortenUrlSlug) {
                // Resolve the short URL via API
                Urls.urlShortenerApi
                    .getShortUrl(shortenUrlSlug, true)
                    .then((data) => {
                        requestedUrl = data.data.url;
                        console.log("resolved short url", requestedUrl);

                        // Support forwarding to asset within app
                        const pathOnly = requestedUrl.split("https://bushfire.io").pop();
                        if (pathOnly) {
                            return Urls.redirectToPath(pathOnly, navigate);
                        }
                    })
                    .catch((e) => {
                        console.warn("unable to open slug url", e);
                    });
            }

            return;
        }

        // Navigate bushfireio://</Url> to </Url>
        if (requestedUrl.includes("bushfireio://")) {
            const localAppSlug = requestedUrl.split("bushfireio://").pop();
            if (localAppSlug) {
                // Stop login flow, if Browser is running
                if (isiOSApp()) {
                    CapacitorBrowser.close().catch((e) => console.warn("error closing window", e));
                }

                return Urls.redirectToPath(localAppSlug, navigate);
            }
        }

        // Navigate *bushfire.io/Url to /Url
        if (requestedUrl.includes("bushfire.io")) {
            const slug = requestedUrl.split("bushfire.io").pop();
            if (slug === "") {
                return Urls.redirectToPath("/", navigate);
            } else if (slug) {
                return Urls.redirectToPath(slug, navigate);
            }
        }
    }

    static urlHasSegment(segment: string) {
        if (!segment) return false;

        const url = new URLSearchParams(window.location.search);
        // console.log(`url: ${window.location.search}`)

        if (url && url.has(segment)) {
            return true;
        }

        return false;
    }

    static redirectToPath(appPath: string, navigate: NavigateFunction | null) {
        console.log("redirectToPath", appPath);
        if (navigate) {
            navigate(appPath);
        } else {
            window.location.href = appPath;
        }
    }

    static replaceStateUrl(appPath: string, navigate: NavigateFunction | null) {
        if (navigate) {
            navigate(appPath, {
                replace: true,
            });
        } else {
            window.history.replaceState({}, "", appPath);
        }
    }

    static urlNoPassword(v: string) {
        try {
            const parsed = new URL(v);
            parsed.password = "";
            return parsed.toString();
        } catch {
            return v;
        }
    }
}
